<template>
	<div class="contents">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<div class="center page-content" :style="{animation:animation}">
			<div class="headers">
				<div class="type flexleft" ref="type">
					<div class="title">类别</div>
					<div :class="typeStatus==1?'hidden':''">
						<div class="typeList flexleft">
							<div :class="typeCurrent==-1?'childs':'child'" @click="typeAll">全部</div>
							<div :class="index==typeCurrent?'childs':'child'" v-for="(item,index) in typeList"
								@click="typeChange(index)">{{item.name}}</div>
						</div>
						<div class="more" v-if="typeStatus==1" @click="typeStatus=2">更多</div>
						<div class="pack" v-if="typeStatus==2" @click="typeStatus=1">收起</div>
					</div>
				</div>
				<div class="type flexleft" ref="tag">
					<div class="title">标签</div>
					<!-- <div class="typeList flexleft">
						<div :class="index==tagCurrent?'childs':'child'" v-for="(item,index) in 16" @click="tagChange(index)">全部</div>
					</div> -->
					<div :class="tagStatus==1?'hidden':''">
						<div class="typeList flexleft">
							<div :class="tagCurrent==-1?'childs':'child'" @click="tagAll">全部</div>
							<div :class="index==tagCurrent?'childs':'child'" v-for="(item,index) in tagList"
								@click="tagChange(index)">{{item.name}}</div>
						</div>
						<div class="more" v-if="tagStatus==1" @click="tagStatus=2">更多</div>
						<div class="pack" v-if="tagStatus==2" @click="tagStatus=1">收起</div>
					</div>
				</div>
				<div class="type flexleft" ref="project">
					<div class="title">专题</div>
					<div class="typeList flexleft">
						<div :class="subjectCurrent==-1?'childs':'child'" @click="subjectAll">全部</div>
						<div :class="index==subjectCurrent?'childs':'child'" v-for="(item,index) in projectList"
							@click="subjectChange(index)">{{item.name}}</div>
						<div class="more" v-if="projectStatus==1" @click="projectStatus=2">更多</div>
						<div class="pack" v-if="projectStatus==2" @click="projectStatus=1">收起</div>
					</div>
				</div>
			</div>
			<div class="rank flexleft">
				<div :class="newOre == 0 ? 'news' : 'new'" @click="changeNew">最新</div>
				<div class="line">|</div>
				<div :class="newOre == 1 ? 'res' : 're'" @click="changeRe">最热</div>
			</div>
			<div class="videoList flexleft">
				<div class="empty" v-if="total == 0">
					<el-empty description="暂无数据"></el-empty>
				</div>
				<div class="child" v-for="(item,index) in list" :key="index" @click="todetail(item.id)">
					<div class="time">{{item.createtime}}</div>
					<div class="topImg">
						<img :src="$index.addurl(item.thum)" alt="">
					</div>
					<div class="bottomTxt">
						<div class="title">{{item.title}}</div>
						<div class="info flexleft">
							<div class="name">{{item.info}}</div>
							<!-- <div class="tag">律师</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="page">
				<el-pagination :hide-on-single-page="true" :current-page="currentPage" :page-size="12"
					@current-change="addPage" layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default {
		components: {
			headerTop
		},
		data() {
			return {
				typeList: [],
				tagList: [],
				projectList: [],
				id: 0,
				contents: '',
				currentPage: 1, //分页当前页数
				total: 0,
				img: '',
				animation: '',
				typeCurrent: -1,
				tagCurrent: -1,
				subjectCurrent: -1,
				typeStatus: 0,
				tagStatus: 0,
				projectStatus: 0,
				newOre: 0,
				typeId: '',
				tagId: '',
				subjectId: '',
				sortTxt: 'new',
				list: [],
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
			this.gettypeList();
		},
		mounted() {
			if (this.$refs.type.offsetHeight > 100) {
				this.typeStatus = 1;
			}
			if (this.$refs.tag.offsetHeight > 100) {
				this.tagStatus = 1;
			}
			if (this.$refs.project.offsetHeight > 100) {
				this.projectStatus = 1;
			}
		},
		methods: {
			typeAll() {
				this.typeId = '';
				this.typeCurrent = -1;
				this.currentPage = 1;
				this.getstudyList();
			},
			tagAll() {
				this.tagId = '';
				this.tagCurrent = -1;
				this.currentPage = 1;
				this.getstudyList();
			},
			subjectAll() {
				this.subjectId = '';
				this.subjectCurrent = -1;
				this.currentPage = 1;
				this.getstudyList();
			},
			getstudyList() {
				let _this = this;
				_this.list = [];
				_this.$api.user.getLessonList({
					type: _this.typeId,
					tag: _this.tagId,
					projectId: _this.subjectId,
					sort: _this.sortTxt,
					page: _this.currentPage,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.data.forEach(item => {
							item.createtime = _this.timestampToTime(item.createtime);
						})
						_this.list = res.data.list.data;
						_this.currentPage = res.data.list.current_page;
						_this.total = res.data.list.total;
					}
				})
			},
			timestampToTime(timestamp) {
				var date = new Date(timestamp * 1000);
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
				var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
				var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
				var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				return Y + M + D;
			},
			gettypeList() {
				let _this = this;
				_this.$api.user.getLessonFilter({}).then(res => {
					if (res.code == 1) {
						_this.typeList = res.data.type;
						_this.tagList = res.data.tag;
						_this.projectList = res.data.project;
						this.getstudyList();
					}
				})
			},
			todetail(id) {
				const {
					href
				} = this.$router.resolve({
					name: 'studydetail',
					query: {
						id: id,
					}
				});
				window.open(href, '_blank');
			},
			addPage(e) {
				this.currentPage = e;
				this.getstudyList();
			},
			changeNew() {
				this.newOre = 0;
				this.sortTxt = 'new';
				this.getstudyList();
			},
			changeRe() {
				this.newOre = 1;
				this.sortTxt = 'hot';
				this.getstudyList();
			},
			getdata() {
				let id = 2;
				let _this = this;
				_this.$api.user.fundServicesDetails({
					id,
				}).then(res => {
					if (res.code == 1) {
						_this.contents = res.data.content;
						_this.img = res.data.background_img;
					}
				})
			},
			typeChange(index) {
				let _this = this;
				_this.typeCurrent = index;
				_this.typeId = _this.typeList[index].id;
				_this.currentPage = 1;
				_this.getstudyList();
			},
			tagChange(index) {
				let _this = this;
				_this.tagCurrent = index;
				_this.tagId = _this.tagList[index].id;
				_this.currentPage = 1;
				_this.getstudyList();
			},
			subjectChange(index) {
				let _this = this;
				_this.subjectCurrent = index;
				_this.subjectId = _this.projectList[index].id;
				_this.currentPage = 1;
				_this.getstudyList();
			},
		},

	}
</script>
<style scoped>
	.empty{
		margin: 50px auto;
	}
	.contents {
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
	}
</style>
<style scoped lang="scss">
	.hidden {
		height: 54px;
		overflow: hidden;
	}

	.swiperImg {
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 250px 0;

		.lTitle {
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}

		.bTitle {
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}

		.sTitle {
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}

	.center {
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 190px;
		padding: 80px 100px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;

		.page {
			margin: auto;
			display: flex;
			justify-content: center;
		}

		.videoList {
			flex-wrap: wrap;

			.child {
				margin: 10px;
				width: 23%;
				position: relative;
				cursor: pointer;

				.time {
					position: absolute;
					top: 6px;
					left: 6px;
					background-color: rgba(0, 0, 0, 0.5);
					padding: 6px;
					color: #fff;
					border-radius: 6px;
				}

				.topImg {
					height: 200px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.bottomTxt {
					padding: 10px;

					.title {
						font-size: 16px;
						color: #333;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
					}

					.info {
						color: lightgray;
						font-size: 14px;
						padding: 6px 0;
						line-height: 28px;
						display: -webkit-box;
						overflow: hidden;
						/*! autoprefixer: off; */
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;

						.tag {
							margin-left: 5px;
						}
					}
				}
			}
		}

		.rank {
			margin: 10px 0;
			font-size: 14px;
			color: #333;
			padding: 0 30px;

			.new {
				cursor: pointer;
			}

			.news {
				cursor: pointer;
				color: #1452DC;
			}

			.res {
				color: #1452DC;
				cursor: pointer;
			}

			.re {
				cursor: pointer;
			}

			.line {
				margin: 0 30px;
			}
		}

		.headers {
			.type {
				padding: 12px 0;
				position: relative;

				.more {
					position: absolute;
					right: 0px;
					top: 30px;
					font-size: 14px;
					cursor: pointer;
				}

				.pack {
					position: absolute;
					right: 0px;
					bottom: 30px;
					font-size: 14px;
					cursor: pointer;
				}

				.title {
					color: #000;
					font-size: 14px;
					width: 100px;
					line-height: 44px;
					text-align: center;
					align-self: flex-start;
				}

				.typeList {
					flex-wrap: wrap;
					max-width: 1030px;

					.child {
						color: #333;
						font-size: 14px;
						padding: 10px 20px;
						width: fit-content;
						text-align: center;
						cursor: pointer;
						margin-bottom: 10px;
					}

					.childs {
						cursor: pointer;
						color: #1452DC;
						background-color: rgba(207, 232, 252, 0.5);
						font-size: 14px;
						padding: 10px 20px;
						width: fit-content;
						text-align: center;
						margin-bottom: 10px;
					}
				}

			}
		}
	}
</style>


// WEBPACK FOOTER //
// study.vue?225ca544